import { schemes, zSchema } from "../schema-validation";
import { EGarnishmentStatus } from "./EGarnishmentStatus";
import { EGarnishmentType } from "./EGarnishmentType";

export const garnishmentStatusSchema = zSchema.nativeEnum(EGarnishmentStatus);

export const garnishmentTypeSchema = zSchema.nativeEnum(EGarnishmentType);

export const garnishmentMutableStatusSchema = zSchema.enum([
  EGarnishmentStatus.Modified,
  EGarnishmentStatus.Vacated,
  EGarnishmentStatus.Cancelled,
]);

export const garnishmentMoneyAmountSchema = zSchema.number().nonnegative();

export const garnishmentCapPercentageSchema = zSchema.number().min(0).max(1);

export const garnishmentOptionalNonEmptyString = (message: string) =>
  schemes.nonEmptyString(message).optional();

export const garnishmentListLimitSchema = zSchema.coerce
  .number()
  .int()
  .min(1)
  .max(100)
  .optional();
